import {createStyles, makeStyles} from '@material-ui/core';
import {desktop} from '../../../const/sizes';

const useStyles = makeStyles(() =>
    createStyles({
        pagingWrapper: {
            padding: `${desktop.contentSmallerSpacing}`,
        },
        wrappingContainer:{
            paddingTop:30,
            paddingBottom:30,
            maxWidth: `1500px`,
        }
    }),
);

export default useStyles;
